<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Hospitals' : 'Deleted Hospitals'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/hospitals/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.country_id"
                    :items="countries"
                    item-text="description"
                    item-value="id"
                    label="Country"
                    hide-details="auto"
                    @input="onCountryFilter"
                    prepend-inner-icon="mdi-earth"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.state_id"
                    :items="states"
                    item-text="description"
                    item-value="id"
                    label="State"
                    hide-details="auto"
                    :disabled="!filter.country_id"
                    @input="onStateFilter"
                    prepend-inner-icon="mdi-map-outline"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.city_id"
                    :items="cities"
                    item-text="description"
                    item-value="id"
                    label="City"
                    hide-details="auto"
                    :disabled="!filter.state_id"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-city"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="hospitals.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start" style="min-width: none">
                        Hospital Name
                      </th>
                      <th class="text-start">Email</th>
                      <th class="text-start">Country</th>
                      <th class="text-start">State</th>
                      <th class="text-start">City</th>
                      <th class="text-start">Address</th>
                      <th class="text-start action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="hospitals.length != 0">
                    <tr
                      v-for="(hospital, i) in hospitals"
                      :key="`hospital_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': hospitals.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="hospital.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Hospital is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="hospital.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Hospital is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ hospital.name || "" }}
                      </td>
                      <td>
                        {{ hospital.email || "" }}
                      </td>
                      <td>
                        {{ hospital.country?.description || "" }}
                      </td>
                      <td>
                        {{ hospital.state?.description || "" }}
                      </td>
                      <td>
                        {{ hospital.city?.description || "" }}
                      </td>
                      <td>
                        {{ hospital.address || "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(hospital.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Hospital</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/hospitals/${encryptIt(hospital.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Hospital</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(hospital.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this hospital</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_hospital" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Hospital deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_hospital = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_hospital" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Hospital restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_hospital = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "hospitalsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        country_id: "",
        state_id: "",
        city_id: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_hospital: false,
      is_restored_hospital: false,
      hospitals: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      countries: [],
      states: [],
      cities: [],
      isLoading: false,
      isExcelloading: false,
    };
  },
  computed: {
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250; // Mobile phones
        case 'sm': return 300; // Tablets
        case 'md': return 400; // Small laptops
        case 'lg': return 500; // Desktop
        case 'xl': return 600; // Large desktop
        default: return 400;
      }
    }
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  async mounted() {
    await this.fetchMasters();
    this.getData();
  },
  methods: {
    isDeletePage() {
      return this.$route.query.open_trash ? true : false;
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.country_id = this.filter.country_id
        ? this.filter.country_id
        : "";
      this.filter.state_id = this.filter.state_id
        ? this.filter.state_id
        : "";
      this.filter.city_id = this.filter.city_id
        ? this.filter.city_id
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&country_id=" +
        this.filter.country_id +
        "&state_id=" +
        this.filter.state_id +
        "&city_id=" +
        this.filter.city_id;

      await axios
        .get(`hospitals?${query}`)
        .then((response) => {
          this.hospitals = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    async Delete_this(id) {
      await axios
        .post(`/hospitals/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_hospital = true;
          this.getData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async Restore_this(id) {
      await axios
        .post(`/hospitals/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.is_restored_hospital = true;
          this.getData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      console.log("Excel export not implemented yet", query);
      this.isExcelloading = false;
    },

    async fetchMasters() {
      try {
        const response = await axios.get('/masters?context=hospital');
        this.countries = response.data.countries || [];
      } catch (error) {
        console.error('Error fetching masters:', error);
      }
    },

    async onCountryFilter() {
      // Reset state and city when country changes
      this.filter.state_id = "";
      this.filter.city_id = "";
      this.states = [];
      this.cities = [];
      
      if (this.filter.country_id) {
        try {
          const response = await axios.get(`/states/${this.filter.country_id}`);
          this.states = response.data || [];
        } catch (error) {
          console.error('Error fetching states:', error);
        }
      }
      this.page = 1;
      this.getData();
    },

    async onStateFilter() {
      // Reset city when state changes
      this.filter.city_id = "";
      this.cities = [];
      
      if (this.filter.state_id) {
        try {
          const response = await axios.get(`/cities/${this.filter.state_id}`);
          this.cities = response.data || [];
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
      }
      this.page = 1;
      this.getData();
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.table-row-even {
  background-color: #f9f9f9;
}
.table-row-odd {
  background-color: white;
}
.sr_no {
  min-width: 85px;
}
</style>
